module.exports = __webpack_public_path__ + "static/media/yy1.883115a1.png";